export default "__VITE_ASSET__87SjBXYw__"